import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";
import walletService from "../../../services/WalletService";
import { storage } from "../../../storageconstants";
import { debugLog } from "../../../utils";
import { translateError } from "../../../errorTranslations";

export default class CoinsubPaymentOptionsController extends Controller {
  static targets = [
    "confirmButton",
    "coins",
    "chains",
    "down"
  ];

  static values = {
    walletaddress: String,
    session: String,
  };

  connect() {
    this.codeValue = sessionStorage.getItem(storage.CODE);
    setTimeout(() => {
      this.checkForAutoSelection();
      this.listenWalletChange();
      this.hideLoadingScreen();
    }, 100);

    this.boundHandleSubmitEnd = this.handleSubmitEnd.bind(this);
    document.addEventListener("turbo:submit-end", this.boundHandleSubmitEnd);
  }

  disconnect() {
    document.removeEventListener("turbo:submit-end", this.boundHandleSubmitEnd);
  }

  async handleSubmitEnd(event) {
    const form = event.detail.formSubmission.formElement;
    if (form.id !== "frame-post-form") return;

    const fetchResponse = event.detail.fetchResponse;
    if (!fetchResponse) return;

    const contentType = fetchResponse.response.headers.get("content-type");
    if (contentType?.includes("application/json")) {
      try {
        const res = await fetchResponse.response;
        const jsonData = await res.json();

        if (jsonData.response_type === "redirect") {
          this.hideLoadingScreen();
          Turbo.visit(jsonData.redirect_url);
        }
      } catch (error) {
        debugLog("Error parsing JSON response:", error);
      }
    }
  }

  selectPaymentOption() {
    this.showLoadingScreen();
    const radioButtons = document.getElementsByClassName("currency-radio-selector");
    let selectedRadioButton;

    for (let i = 0; i < radioButtons.length; i++) {
      if (radioButtons[i].checked) {
        selectedRadioButton = radioButtons[i];
        const tokenid = selectedRadioButton.getAttribute("data-coinsub-payment-options-tokenid-param");
        const networkid = selectedRadioButton.getAttribute("data-coinsub-payment-options-networkid-param");
        this.renderPaymentMethod(tokenid, networkid);

        const form = document.getElementById("frame-post-form");
        form.action = `/${this.codeValue}/review?session=${this.sessionValue}`;
        document.getElementById("form_session").value = this.sessionValue;
        document.getElementById("form_address").value = this.walletaddressValue;
        document.getElementById("form_networkid").value = networkid;
        document.getElementById("form_tokenid").value = tokenid;
        form.requestSubmit();
        break;
      }
    }
  }

  checkForAutoSelection() {
    const radioButtons = document.getElementsByClassName("currency-radio-selector");
    for (let i = 0; i < radioButtons.length; i++) {
      if (radioButtons[i].checked) {
        this.enableConfirmButton();

        if (this.chainsTargets.length > 0) {
          this.chainsTargets.forEach((chain, index) => {
            chain.classList.remove("grid-rows-[1fr]");
            this.downTargets[index].classList.remove("rotate-180");
          });
          this.chainsTargets[0].classList.add("grid-rows-[1fr]");
          this.downTargets[0].classList.add("rotate-180");
        }
        break;
      }
    }
  }

  enableConfirmButton() {
    this.confirmButtonTarget.classList.remove("is-disabled");
  }

  async showChainsEventHandler(event) {
    const tokenId = event.currentTarget.getAttribute("data-token-id");
    this.chainsTargets.forEach((chain, index) => {
      if (chain.getAttribute("data-token-id") === tokenId) {
        chain.classList.add("grid-rows-[1fr]");
        this.downTargets[index].classList.add("rotate-180");
      } else {
        chain.classList.remove("grid-rows-[1fr]");
        this.downTargets[index].classList.remove("rotate-180");
      }
    });
  }

  async selectToken(e) {
    const tokenId = e.currentTarget?.dataset?.tokenId;
    const networkId = e.currentTarget?.dataset?.networkId;
    if (!tokenId || !networkId) return;

    const code = sessionStorage.getItem(storage.CODE);
    const sessionId = sessionStorage.getItem(storage.SESSION);
    if (!code || !sessionId) return;
    this.renderPaymentMethod(tokenId, networkId);
  }

  async renderPaymentMethod(tokenId, networkId) {
    const code = sessionStorage.getItem(storage.CODE);
    const sessionId = sessionStorage.getItem(storage.SESSION);

    const httpReq = await fetch(`/${code}/payment-method`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Session": sessionId,
        "X-Code": code,
      },
      body: JSON.stringify({ tokenId, networkId })
    });

    const jsonData = await httpReq.json();
    if (jsonData.error) return;

    if (jsonData.success && jsonData.type === "html") {
      Turbo.renderStreamMessage(jsonData.data);
    }
  }

  async connectWallet() {
    try {
      this.dispatch("listenWalletChange", { bubbles: true });
      this.showLoadingScreen();
      await walletService.connectWallet();
      this.hideLoadingScreen();
    } catch (error) {
      debugLog("Error connecting wallet:", error);
      this.hideLoadingScreen();
      this.dispatch("error", { detail: { content: translateError(error, "Failed to connect wallet. Please try again.") } });
    }
  }

  listenWalletChange() {
    this.dispatch("listenWalletChange");
  }

  showLoadingScreen() {
    this.dispatch("showLoadingScreen", { detail: { text: "Please Wait" } });
  }

  hideLoadingScreen() {
    this.dispatch("hideLoadingScreen");
  }
}
